import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { getOpacityColor, grayScale } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";
import { HEADER_SIZE } from "@styles/variables";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 100%;
  /* HACK: Height가 body부터 명확히 정해져 있지 않기 때문에 하위 요소에도 모두 min-height view height를 적용해주어야 컨텐츠 크기가 작을 때도 꽉 채워진 화면을 볼 수 있음.
  + Contents가 들어가는 곳은 Header HEIGHT가 제외된 크기 */
  height: calc(100% - ${HEADER_SIZE.HEIGHT}px);
  min-height: calc(100vh - ${HEADER_SIZE.HEIGHT}px);
  min-height: calc((var(--vh, 1vh) * 100) - ${HEADER_SIZE.HEIGHT}px);
  padding: 80px 20px 0;

  background-color: ${grayScale[200]};
`;

export const Title = styled(Typo.Heading)`
  width: 100%;
  margin-bottom: 16px !important;

  text-align: left;
`;

export const Description = styled(Typo.Text)`
  width: 100%;
  margin-bottom: 92px !important;

  text-align: left;
`;

export const AuthEntryForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  margin-bottom: 60px;
`;

export const OrSeparator = styled.div`
  position: relative;

  margin: 32px 0;

  color: ${grayScale.white};
  text-align: center;

  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 50%;

    width: 40%;
    height: 1px;

    background-color: ${grayScale.white};
  }

  &:before {
    left: 0;
  }

  &:after {
    right: 0;
  }
`;

export const SocialButton = styled(motion.button)`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 48px;
  padding: 12px;
  border: 1px solid ${getOpacityColor(grayScale.black, 0.2)};
  border-radius: 8px;

  background-color: ${grayScale.main};

  cursor: pointer;
`;

export const ButtonText = styled(Typo.Text)`
  display: inline-block;

  color: ${grayScale[300]} !important;
`;

export const GoogleButton = styled(SocialButton)`
  background-color: ${grayScale.white};

  color: ${grayScale.black};
`;

export const KakaoButton = styled(SocialButton)`
  background-color: #fee500;
`;

export const AppleButton = styled(SocialButton)`
  background-color: ${grayScale.black};

  ${ButtonText} {
    color: ${grayScale.white} !important;
  }
`;
